import { useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { RootWidthContext } from "../../rootWidth/index.js";
const useMatchQuery = (query)=>{
    const rootWidth = useContext(RootWidthContext);
    const mediaQuery = useMediaQuery(query);
    if ('number' == typeof rootWidth) {
        const isMinWidth = query.includes('min-width');
        const isMaxWidth = query.includes('max-width');
        const queryWidth = parseInt(query.match(/\d+/));
        if (isMinWidth) return rootWidth >= queryWidth;
        if (isMaxWidth) return rootWidth <= queryWidth;
    }
    return mediaQuery;
};
export { useMatchQuery };
